var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { map } from 'rxjs/operators';
import { FILTER_COLLATION, FILTER_GROUPING_OPERATION, FILTER_OPERATION } from "../filter/types";
export var METHOD;
(function (METHOD) {
    METHOD["GET"] = "get";
    METHOD["POST"] = "post";
    METHOD["PATCH"] = "patch";
    METHOD["PUT"] = "put";
    METHOD["DELETE"] = "delete";
    METHOD["UPDATE"] = "patch";
    METHOD["CREATE"] = "post";
    METHOD["READ"] = "get";
})(METHOD || (METHOD = {}));
var isListResult = function (data) {
    return (typeof data === 'object' &&
        data !== null &&
        data.hasOwnProperty('items') &&
        Array.isArray(data.items) &&
        typeof data.totalCount === 'number');
};
var filterExprValueIsEmpty = function (filterExpr) {
    return (filterExpr.value == null ||
        filterExpr.value === '' ||
        (Array.isArray(filterExpr.value) && !filterExpr.value.length));
};
var filterPropsMapper = function (filtersProps) {
    return filtersProps
        .map(function (filterExpr) {
        if (filterExpr.property !== null) {
            return __assign({ operation: FILTER_OPERATION.contains, collation: FILTER_COLLATION.ignorecase }, filterExpr);
        }
        else {
            return __assign(__assign({}, filterExpr), { items: filterPropsMapper(filterExpr.items) });
        }
    })
        .filter(function (filterExpr) {
        if (filterExpr.property !== null) {
            return filterExpr.property && !filterExprValueIsEmpty(filterExpr);
        }
        else {
            return !!filterExpr.items.length;
        }
    });
};
var HttpProxy = /** @class */ (function () {
    function HttpProxy(options) {
        this.params = {};
        this.filterQueryParams = {};
        this.method = options.method || METHOD.GET;
        this.requestEncoder = options.requestEncoder;
        this.url = options.url || '';
        this.isFileUpload = !!options.isFileUpload;
        this.mapper = typeof options.mapper === 'function' ? options.mapper : function (data) { return data; };
        this.ignoreListResult = !!options.ignoreListResult;
    }
    /**
     * Make request for load or upload data, return rxjs stream
     * @param payload - request payload data
     * @param loadParams - request params data
     * @param loadFilterQuery - request filter query params
     */
    HttpProxy.prototype.load = function (payload, loadParams, loadFilterQuery) {
        var _this = this;
        var params = __assign(__assign({}, this.params), (loadParams || {}));
        var filterQueryParams = __assign(__assign({}, this.filterQueryParams), (loadFilterQuery || {}));
        var _a = this, request = _a.request, method = _a.method, baseUrl = _a.url, isFileUpload = _a.isFileUpload;
        if (!request) {
            throw new Error('HttpProxy error: before load must bee setted context via setContext');
        }
        var requestUrl = typeof baseUrl === 'function' ? baseUrl(params) : baseUrl;
        var url = requestUrl.replace(/:(\w+)/g, function (_, paramName) {
            var value = params[paramName];
            if (!value && value !== 0) {
                throw new Error("HttpProxy error: param \"" + paramName + "\" must be defined");
            }
            return String(value);
        });
        url = this.getUrlWithQuery(url, filterQueryParams);
        return request
            .execute(method, url, payload || null, {
            fileUpload: !!isFileUpload,
            requestEncoder: this.requestEncoder
        })
            .pipe(map(function (result) {
            var resultData = result.data;
            var totalCount;
            if (!_this.ignoreListResult && isListResult(resultData)) {
                totalCount = resultData.totalCount;
                resultData = resultData.items;
            }
            return {
                meta: {
                    status: result.meta.status,
                    totalCount: totalCount
                },
                data: _this.mapper(resultData, params)
            };
        }));
    };
    /**
     * Set request context, such as request transport object
     */
    HttpProxy.prototype.setContext = function (request) {
        this.request = request;
    };
    /**
     * Set common request params
     */
    HttpProxy.prototype.setParams = function (params) {
        this.params = params;
    };
    /**
     * Set filter query params
     */
    HttpProxy.prototype.setFilterQueryParams = function (params) {
        this.filterQueryParams = params;
    };
    HttpProxy.prototype.getUrlWithQuery = function (url, filterQuery) {
        var resultUrl = url;
        resultUrl += this.getFilterQuery(resultUrl, filterQuery.filters);
        resultUrl += this.getSortQuery(resultUrl, filterQuery.sort);
        resultUrl += this.getPaginationQuery(resultUrl, filterQuery.start, filterQuery.limit);
        return resultUrl;
    };
    HttpProxy.prototype.getFilterQuery = function (url, filtersProps) {
        if (filtersProps === void 0) { filtersProps = []; }
        var query = filterPropsMapper(Array.isArray(filtersProps)
            ? [
                {
                    property: null,
                    operation: FILTER_GROUPING_OPERATION.and,
                    items: filtersProps
                }
            ]
            : [filtersProps]);
        var concatOperator = this.getConcatOperator(url);
        return query.length
            ? concatOperator + "Filter=" + encodeURIComponent(JSON.stringify(query.length === 1 ? query[0] : query, function (key, value) {
                return value === null ? undefined : value;
            }))
            : '';
    };
    HttpProxy.prototype.getSortQuery = function (url, sorting) {
        if (sorting === void 0) { sorting = {}; }
        var sortList = Array.isArray(sorting) ? sorting : [sorting];
        sortList = sortList.filter(function (_a) {
            var property = _a.property, direction = _a.direction;
            return property && direction;
        });
        if (!sortList.length) {
            return '';
        }
        var concatOperator = this.getConcatOperator(url);
        var query = sortList.map(function (_a) {
            var property = _a.property, direction = _a.direction, _b = _a.collation, collation = _b === void 0 ? FILTER_COLLATION.ignorecase : _b;
            return ({
                property: property,
                direction: direction,
                collation: collation
            });
        });
        return concatOperator + "Sort=" + encodeURIComponent(JSON.stringify(query));
    };
    HttpProxy.prototype.getPaginationQuery = function (url, start, limit) {
        if (typeof start !== 'number' || typeof limit !== 'number') {
            return '';
        }
        var concatOperator = this.getConcatOperator(url);
        var encodeStart = encodeURIComponent(start);
        var encodeLimit = encodeURIComponent(limit);
        return concatOperator + "Offset=" + encodeStart + "&Limit=" + encodeLimit;
    };
    HttpProxy.prototype.getConcatOperator = function (url) {
        return url.includes('?') ? '&' : '?';
    };
    /**
     * Has response data
     * @param data
     */
    HttpProxy.prototype.isEmpty = function (data) {
        return data == null || data === '' || (Array.isArray(data) && !data.length);
    };
    return HttpProxy;
}());
export { HttpProxy };
//# sourceMappingURL=HttpProxy.js.map